import { Component, Inject, OnInit, ViewChild, ElementRef, EventEmitter } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Account } from 'globals/store/accounts.data';
import { JoiEvent, WFWorker, WorkforceGroup } from 'src/app/store/events.era';
import { LabelUpdateFunctionParams } from 'src/app/components/label-marker/label-maker.dialog.component';
import { ManageWrapperComponent, TabGroup } from './manage-wrapper.component';
import { taskTabs, Task, Subtask, TimeLogSummary, LogEntry, OMEGA_GROUP_NAME, taskStatusNames, TaskStatus } from 'globals/store/tasks.data';
import { Label } from 'globals/store/events.data';
import { eventDateStringReselector } from 'src/app/store/reselectors/events.reselector';
import { JoiFile } from 'globals/store/files.model';
import { JoiComment } from 'globals/store/tasks.data';
import { timeLogReselector } from 'src/app/store/reselectors/tasks.reselector';
import { TimeLogData } from 'src/app/helpers/table-column-types';
import { HMTimes, JoiHMInputComponent } from 'src/app/components/joi-input/joi-hm-input.component';
import { sleepForMS } from '../../helpers/helpers';
import { openDialogGetResult } from 'src/app/helpers/angular-helpers';
import { ConfirmDeleteData, openConfirmDeleteGetResult } from 'src/app/components/dialog.confirmDelete.component';
import { PeoplePickerData, PeoplePickerComponent } from 'src/app/components/people-picker/people-picker.component';
import { DropdownOption, Program } from 'globals/store/programs.data';
import { programsArray } from 'src/app/store/reselectors/programs.reselector';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { ManageTaskData, ManageTaskReturnType } from './manage-task-data';
import { getTaskTriggers } from 'src/app/store/tasks.era';
import { ChatBoxComponent } from './chat-box.component';
import { TASK_SAVE_DEBOUNCE_AND_SKIP_DUPLICATE_MS } from 'src/app/helpers/constants';
import { AllEntitySelectData, AllEntitySelectDialogComponent } from 'src/app/components/entities/all-entity-select.dialog.component';
import { Dictionary } from '@ngrx/entity';
import { entitiesReselector } from 'src/app/store/reselectors/entity.reselector';
import { Wrapper } from 'src/app/components/wrapper.component';
import { Subject } from 'rxjs';
import { CdkDrag, CdkDragDrop, CdkDragHandle, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
import { TypedEntity } from 'globals/store/entity.shared.data';
import { createId, date2str, jsonCopyObject } from 'globals/helpers/helpers';
import { IconComponent } from 'src/app/components/icon/icon.component';
import { PhotoComponent } from 'src/app/components/photo';
import { MenuHoverButtonComponent } from 'src/app/components/buttons/menu-hover-button.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSelectModule } from '@angular/material/select';
import { TitleIconComponent } from 'src/app/components/icon/title-icon.component';
import { JoiInputComponent } from 'src/app/components/joi-input/joi-input.component';
import { AddManageWrapperComponent } from 'src/app/components/wrappers/add-manage-wrapper.component';
import { FileHandlerComponent } from 'src/app/components/file-handler/file-handler.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { JustTimeToHHMM } from 'src/app/services/pipes/justTimeToHHMM.pipe';
import { TaskStatusDropdownComponent } from '../tasks/task-status-dropdown.component';
import { TimeLogComponent } from './time-log.component';
import { MatButtonModule } from '@angular/material/button';
@Component({
    selector: 'manage-task',
    templateUrl: './manage-task.html',
    styleUrls: ['./manage-dialogs.scss', './entity-drag.scss'],
    standalone: true,
    imports: [ManageWrapperComponent, MatButtonModule, TimeLogComponent, TaskStatusDropdownComponent, IconComponent, PhotoComponent, MenuHoverButtonComponent, MatFormFieldModule, MatInputModule, MatDatepickerModule, MatSelectModule, JoiHMInputComponent, TitleIconComponent, JoiInputComponent, AddManageWrapperComponent, FileHandlerComponent, CommonModule, ChatBoxComponent, CdkDropList, CdkDrag, CdkDragHandle, FormsModule, JustTimeToHHMM]
})
export class ManageTaskComponent extends Wrapper<ManageTaskComponent> implements OnInit {
  task: Task
  cachedTask: Task // an initial copy of the task to compare to when closing dialog (for notifications)
  _file = 'manage-task'
  labels: Label[] = []
  labelMap: { [id: string]: Label }
  event: JoiEvent
  account: Partial<Account>
  showEstimatedTime = false
  min = Math.min

  taskTabs = taskTabs
  tabGroups: TabGroup[] = [{
    tabs: [
      { id: taskTabs.info, name: 'Task info' },
      { id: taskTabs.messages, name: 'Messages', unseenComments: 0 },
      { id: taskTabs.logs, name: 'Time log' },
    ]
  }]

  selectedTab
  limited = true
  readOnly = true
  eventDateString = ''
  timeLogSummary: TimeLogSummary
  timeLogData: TimeLogData[]
  today = new Date()
  workforce: WFWorker[] = []
  wf_groups: WorkforceGroup[]
  programs: Program[]
  programEntities: { [pId: string]: Program } = {}
  workersByUId: { [key: string]: WFWorker } = {}
  workersByEmail: { [key: string]: WFWorker } = {}
  entities: Dictionary<TypedEntity> = {}
  
  // BOOLEANS FOR TRIGGERS
  checkRemindTime = false
  checkCompletedStatus = false
  checkResponsibility = false
  saveTaskDebounce = new Subject<null>()
  isSaveTaskDebouncing = 0;

  @ViewChild('responsibilityButton') responsibilityButton: ElementRef
  @ViewChild(ChatBoxComponent) chatBox: ChatBoxComponent

  constructor(public dialogRef: MatDialogRef<ManageTaskComponent>, @Inject(MAT_DIALOG_DATA) public data: ManageTaskData) {
    super()
    this.subCallback(this.store.select('workforce'), ({ workforce, workersByUId, workersByEmail, wf_groups }) => {
      this.workersByUId = workersByUId
      this.workersByEmail = workersByEmail
      this.workforce = workforce
      this.wf_groups = wf_groups
    })

    this.subProp(this.store.select(programsArray), 'programs')
    this.subProp(this.store.select(entitiesReselector), 'entities')
    this.subProp(this.store.select('programs', 'entities'), 'programEntities')
    this.subProp(this.store.select('accounts', 'account'), 'account')
    this.subCallback(this.store.select('events', 'labelMaps', 'task_labels'), labels => {
      this.labels = Object.values(labels)
      this.labelMap = labels
    })
    this.subProp(this.store.select('events', 'event'), 'event')
    this.subProp(this.store.select(eventDateStringReselector), 'eventDateString')
  }

  ngOnInit() {
    const { readOnly, limited, task } = this.data
    const taskId = task.id
    this.cachedTask = jsonCopyObject(task)
    this.readOnly = readOnly
    this.limited = !!limited
    this.task = jsonCopyObject(task)
    this.subCallback(this.store.select('tasks', 'entities', taskId), task => {
      if (!task) return
      this.task = jsonCopyObject(task)
      this.commentBookmarkCheck()
    })
    this.subCallback(this.store.select(timeLogReselector, taskId), ({ summary, logs }) => {
      this.timeLogSummary = summary
      this.timeLogData = logs
    })
    this.subObservableWithDebounce(this.saveTaskDebounce, TASK_SAVE_DEBOUNCE_AND_SKIP_DUPLICATE_MS, _ => this.debouncedSaveTask())
  }

  viewEvent() {
    this.eventService.unloadHomeConnectionsToEvents() // Because the event is preloaded, event.service doesn't know to disconnect from home events, so it has to be done here manually
    this.eventService.openingEvent(null, this.event)
    this.dialogRef.close()
  }

  changeEstimatedTime(times: HMTimes) {
    this.task.estimatedTime = !times || times.minutes === 0 ? null : times.justTime
    this.saveTask()
  }

  async removeDueDate(event) {
    const rect = event.target.getBoundingClientRect();
    const data: ConfirmDeleteData = {
      rect,
      title: 'Delete due date',
      dialog: this.dialog
    }
    const del = await openConfirmDeleteGetResult(data)
    if (!del) return
    this.task.dueDate = null
    this.task.date = null
    this.checkRemindTime = true
    this.saveTask()
  }

  setDueDate(date) {
    this.task.dueDate = date2str(new Date(new Date(date).setHours(0, 0, 0, 0)))
    this.checkRemindTime = true
    this.saveTask()
  }

  commentBookmarkCheck() {
    // checks for new comments or marks new comments as seen for the message tab
    const messageTab = this.tabGroups[0].tabs.find(t => t.id === taskTabs.messages)
    if (this.selectedTab && this.selectedTab.id === taskTabs.messages) {
      const commentBookmarks = this.taskService.getUpdatedAsReadCommentBookmarksOrNull(this.task)
      messageTab.unseenComments = 0
      if (!commentBookmarks) return
      this.task = { ...this.task, commentBookmarks }
      this.saveTask()
    } else {
      const seenComments = this.task.commentBookmarks ? this.task.commentBookmarks[this.userService.uid] || 0 : 0
      const totalComments = this.task.comments ? this.task.comments.length : 0
      messageTab.unseenComments = totalComments - seenComments
    }
  }

  toggleFlagged() {
    this.task.flag = !this.task.flag
    this.saveTask()
  }

  changeTab(tab) {
    this.selectedTab = tab
    this.commentBookmarkCheck()
  }

  addLog(log: LogEntry) {
    if (!this.task.log) this.task.log = []
    this.task.log.push(log)
    this.saveTask()
  }

  editLog(log: LogEntry) {
    const index = this.task.log.findIndex(l => l.id === log.id)
    this.task.log[index] = log
    this.saveTask()
  }

  deleteLog(logId: string) {
    const index = this.task.log.findIndex(l => l.id === logId)
    if (isNaN(index)) return
    this.task.log.splice(index, 1)
    this.saveTask()
  }

  toggleEstimatedTime(event, open, fromOutside = false) {
    if (event && (!fromOutside || (fromOutside && this.showEstimatedTime))) {
      event.stopPropagation()
    }
    this.showEstimatedTime = open
  }

  debouncedSaveTask() {
    this.isSaveTaskDebouncing--;
    this.taskService.updateTask(this.task.id, this.task)
  }

  saveTask() {
    this.isSaveTaskDebouncing++;
    this.saveTaskDebounce.next(null)
  }

  saveFiles(files: JoiFile[]) {
    this.task.files = files
    this.saveTask()
  }

  updateProgram() {
    this.saveTask()
  }

  async addSubtask() {
    if (!this.task.subtasks) {
      this.task.subtasks = []
      this.task.subtasks_obj = {}
    }
    const id = createId()
    this.task.subtasks.push(id)
    this.task.subtasks_obj[id] = { id, name: "" }

    this.saveTask()

    // focus newly generated subtask
    let joiInputHTMLRef
    do await sleepForMS(25)
    while (!(joiInputHTMLRef = document.getElementById(id))) 
    joiInputHTMLRef.getElementsByTagName('input')[0].focus()

  }

  dropSubtaskIds(event: CdkDragDrop<string[]>) {
    // console.log({ event })
    const newIds = [...this.task.subtasks]
    moveItemInArray(newIds, event.previousIndex, event.currentIndex)
    if (JSON.stringify(this.task.subtasks) === JSON.stringify(newIds)) return    
    this.task.subtasks = newIds
    this.saveTask()
  }


  addComment(comment: JoiComment) {
    this.task.comments = (this.task.comments || []).concat(comment);
    if (!this.task.commentBookmarks) this.task.commentBookmarks = {}
    this.task.commentBookmarks[this.userService.uid] = this.task.comments.length
    this.saveTask()
  }

  saveSubtaskName(subtask: Subtask) {
    this.saveTask()
  }

  toggleSubtask(subtask: Subtask) {
    const { update_subtask, subtasksCompleted } = this.taskService.getToggleSubtaskCompleteData(this.task, subtask)
    const { subtasks_obj } = this.task
    subtasks_obj[update_subtask.id] = update_subtask
    this.task = { ...this.task, subtasks_obj, subtasksCompleted }
    this.saveTask()
  }

  async deleteSubtask(subtask: Subtask, event) {
    const rect = event.target.getBoundingClientRect();
    const data: ConfirmDeleteData = {
      rect,
      title: 'Delete subtask',
      dialog: this.dialog
    }
    const del = await openConfirmDeleteGetResult(data)
    if (!del) return
    if (subtask.completed) this.task.subtasksCompleted--
    this.task.subtasks.splice(this.task.subtasks.findIndex(s => this.task.subtasks_obj[s].id === subtask.id), 1)
    delete this.task.subtasks_obj[subtask.id]
    this.saveTask()
  }

  updateTaskName(name) {
    console.log({ name })
    this.task.name = name
    this.saveTask()
  }

  toggleComplete() {
    this.task.completed = !this.task.completed
    this.checkRemindTime = true
    this.checkCompletedStatus = true
    this.saveTask()
  }

  async associateTask() {
    // console.log("Associating...")
    const rect = document.getElementById('entityButton').getBoundingClientRect()
    const data: AllEntitySelectData = { selectedId: this.task.entityId, rect, includeAssets: true, includeResources: true, includeAttendees: true }
    console.log({ data })
    await openDialogGetResult(this.dialog, AllEntitySelectDialogComponent, { width: '300px', autoFocus: false, backdropClass: 'clear', data })
    if ((!data.selectedId && !this.task.entityId ) || data.selectedId === this.task.entityId) return
    this.task.entityId = data.selectedId
    // console.log({ rect, data })
    this.saveTask()
  }

  async manageVisibility() {
    const rect = document.getElementById('visibilityButton').getBoundingClientRect()
    if (this.data.limited) return
    const selected = { people: {}, groups: {} }
    const { visibility, groupVisibility } = this.task
    visibility && visibility.forEach(email => selected.people[email] = true)
    groupVisibility && groupVisibility.forEach(name => selected.groups[name] = true)

    const taskCreator = this.workersByUId[this.task.createdBy]
    const mandatoryEntry = { people: {}, groups: {} }
    if (taskCreator) mandatoryEntry.people[taskCreator.email] = true
    if (this.task.responsibility) mandatoryEntry.people[this.task.responsibility] = true

    const destroy: Subject<boolean> = new Subject()
    const emitter: EventEmitter<any> = new EventEmitter()
    const data: PeoplePickerData = {
      x: rect.left, 
      y: rect.top + 39,
      people: this.workforce.filter(worker => worker.uid !== this.task.createdBy && worker.email !== this.task.responsibility),
      groups: this.wf_groups,
      multi: true,
      selected,
      emitter,
      mandatoryEntry,
      taskCreator,
      taskResponsiblePerson: this.workersByEmail[this.task.responsibility],
      title: 'Visibility'
    }
    // console.log({ data: jsonCopyObject(data), workforce: this.workforce, visibility, groupVisibility, task: this.task })

    let visibilityChanges
    emitter.pipe(takeUntil(destroy)).subscribe(visibility => visibilityChanges = visibility)
    await openDialogGetResult(this.dialog, PeoplePickerComponent, { width: '300px', autoFocus: false, backdropClass: 'clear', data})
    destroy.next(true)
    destroy.complete()
    // console.log({ visibilityChanges, task: this.task })

    if (!visibilityChanges) return
    this.task.visibility = Object.entries(visibilityChanges.people).filter(([_, selected]) => selected).map(([email , _]) => email)
    this.task.groupVisibility = Object.entries(visibilityChanges.groups).filter(([_, selected]) => selected).map(([name , _]) => name)
    this.saveTask()
  }

  async setResponsibleWorker() {
    const selected = { people: {} }
    const rect = document.getElementById('responsibilityButton').getBoundingClientRect()


    const previousResponsibleParty = this.task.responsibility
    if (previousResponsibleParty) selected.people[previousResponsibleParty] = true
    const data: PeoplePickerData = {
      x: rect.left,
      y: rect.top + 39,
      people: this.workforce,
      groups: null,
      multi: false,
      selected: selected,
      singleSelection: true,
      allGroupName: OMEGA_GROUP_NAME,
      title: 'Responsibility',
    }

    const response = await openDialogGetResult<{ selected: string }>(this.dialog, PeoplePickerComponent, { width: '300px', autoFocus: false, backdropClass: 'clear', data })

    if (!response) return
    const result = response.selected

    if (result && (!previousResponsibleParty || result !== previousResponsibleParty)) {
      this.checkRemindTime = true
      this.checkResponsibility = true
      this.changeResponsibleWorker(result)
    }
    if (result && previousResponsibleParty === result) {
      this.changeResponsibleWorker(null)
      this.checkRemindTime = true
      this.checkResponsibility = true
    }
  }

  changeResponsibleWorker(responsibleWorkerEmail: string) {
    this.task.responsibility = responsibleWorkerEmail
    if (!this.task.visibility.includes(responsibleWorkerEmail)) this.task.visibility.push(responsibleWorkerEmail)
    this.saveTask()
  }

  delete() {
    const returnType: ManageTaskReturnType = 'Delete'
    this.taskService.deleteTask(this.task)
    this.sendTriggers(true)
    this.dialogRef.close(returnType)
  }

  public labelUpdateFunction({ labels, labelTemplate, labelsToggled, labelsChanged }: LabelUpdateFunctionParams) {
    if (labelsChanged) {
      this.eventService.updateEventLabels({ eventId: this.event.eventId, type: 'task_labels', template: labelTemplate })
    }
    if (labelsToggled) {
      this.task.labels = labels
      this.saveTask()
    }
  }


  async confirmDiscardMessageDraft(): Promise<boolean> {
    if (this.selectedTab && this.selectedTab.id === taskTabs.messages && this.chatBox.newMessage) {
      const confirmCloseData: ConfirmDeleteData = {
        dialog: this.dialog,
        title: 'Close this task without sending the message above',
        para: 'You can send the message by clicking cancel and then the send arrow.',
        rect: document.getElementById("farRightButton").getBoundingClientRect(),
        deleteButtonText: 'CLOSE'
      }
      return await openConfirmDeleteGetResult(confirmCloseData)
    }
    return true
  }


  async exit() {
    const canExit = await this.confirmDiscardMessageDraft()
    if (!canExit) return
    this.sendTriggers();
    setTimeout(_=>{
      this.dialogRef.close()
    }, this.isSaveTaskDebouncing > 0 ? TASK_SAVE_DEBOUNCE_AND_SKIP_DUPLICATE_MS : 0)
  }

  sendTriggers(deleted = false) {
    const { task, cachedTask } = this
    const { email, uid } = this.userService
    const triggers = getTaskTriggers()

    // the logic here is a little bit iffy, but better to be more inclusive than less, according to Greg
    triggers.should_update_remindTime = this.checkRemindTime && (
      (task.responsibility !== cachedTask.responsibility && (!!task.responsibility || !!cachedTask.responsibility)) || // extra check for values because sometimes null is being compared to undefined
      (task.responsibility && task.dueDate !== cachedTask.dueDate) ||
      (task.responsibility && task.dueDate && task.completed !== cachedTask.completed)
    )

    triggers.task_status_has_changed = this.checkCompletedStatus && task.completed !== cachedTask.completed

    // extra check if task created via workforce 
    if (task.responsibility && task.responsibility !== email && (this.data.createdForWorker || (this.checkResponsibility && task.responsibility && task.responsibility !== cachedTask.responsibility)))triggers.will_be_responsible = task.responsibility

    if (this.checkResponsibility && cachedTask.responsibility && cachedTask.responsibility !== task.responsibility && cachedTask.responsibility !== email) triggers.wont_be_responsible = cachedTask.responsibility

    // don't need to set flag for deleted as it is set directly in the method call
    if (deleted && task.responsibility && task.responsibility !== email) triggers.was_responsible_on_delete = task.responsibility    
      
    const creator = this.workersByUId[task.createdBy]
    if (deleted && task.createdBy !== uid && creator) triggers.inform_creator_on_delete = creator.email
    
    if (Object.values(triggers).some(v => !!v)) {
      // some trigger is truthy
      console.log("Triggers being sent out", { triggers, task, cachedTask })
      this.taskService.checkTriggersAndTaskToSendNotifications(task, triggers)
    }
      
  }

}

export { ManageTaskReturnType, ManageTaskData }
